// assets/pamela-addon-config.js
window.PAMELA_ADDON_CONFIG = {
  currencySymbol: "$",

  handles: {
    back: "lettering-on-back",
    back_word: "back-engraving-additional-word",
    back_extra_area: "back-engraving-extras",
    vase: "vase-engraving",
    porcelain: "porcelain-portrait-installed",
    panel: "back-engraved-panel",
    panel_upgrade: "back-engraved-panel-upgraded",
    scene: "back-decorative-scene",
    laser_spot: "laser-etching-spot",
    laser_scene: "laser-etching-scene",
    laser_portrait: "laser-etching-portrait",
    image_enhancement: "photo-editing-service"
  },

  skuRoles: {
    back_single: "ADDON_BACK_SINGLE",
    back_companion: "ADDON_BACK_COMPANION",
    back_word: "ADDON_BACK_WORD",
    back_extra_area: "ADDON_BACK_EXTRA_AREA",
    vase_front: "ADDON_VASE_FRONT",
    vase_back: "ADDON_VASE_BACK",
    laser_additional_face: "ADDON_LASER_ADDITIONAL_FACE",
    image_enhancement: "ADDON_IMAGE_ENHANCEMENT",

    scene_10: "ADDON_SCENE_10",
    scene_15: "ADDON_SCENE_15",
    scene_20: "ADDON_SCENE_20",
    scene_24: "ADDON_SCENE_24",
    scene_28: "ADDON_SCENE_28",
    scene_30: "ADDON_SCENE_30",
    scene_36: "ADDON_SCENE_36",
    scene_42: "ADDON_SCENE_42",
    scene_48: "ADDON_SCENE_48"
  },

  // ALL back clipart is priced by size (BACK ONLY; front is free). Price is by
  // the LARGER of the clipart's on-stone width/height, floored to the whole inch
  // (rounding in the customer's favor), bracketed to the smallest tier >= that
  // size. The two low tiers (10/15) replace the old flat $50-each clipart fee.
  // The grey-out FILTER (Scenic category only) instead uses each scene's NATIVE
  // svg width vs the stone's usable width (oversized scenes can't be reduced for
  // sandblast); stoneSizesIn rounds the grey-out label up to a real stone size.
  sandblastScene: {
    backOnly: true,
    // Clipart-library category that marks an item as a fit-FILTERED scene (used
    // for grey-out only; pricing now applies to all back clipart regardless of
    // category). Pamela's uploads use "Scenic" (registry slugifies -> "scenic").
    categoryId: "scenic",
    stoneSizesIn: [20, 24, 28, 30, 36, 42, 48],
    brackets: [
      { maxWidthIn: 10, sku: "ADDON_SCENE_10", price: 50 },
      { maxWidthIn: 15, sku: "ADDON_SCENE_15", price: 100 },
      { maxWidthIn: 20, sku: "ADDON_SCENE_20", price: 150 },
      { maxWidthIn: 24, sku: "ADDON_SCENE_24", price: 200 },
      { maxWidthIn: 28, sku: "ADDON_SCENE_28", price: 225 },
      { maxWidthIn: 30, sku: "ADDON_SCENE_30", price: 250 },
      { maxWidthIn: 36, sku: "ADDON_SCENE_36", price: 300 },
      { maxWidthIn: 42, sku: "ADDON_SCENE_42", price: 375 },
      { maxWidthIn: 48, sku: "ADDON_SCENE_48", price: 450 }
    ]
  },

  includedWords: { single: 10, companion: 20 },

  // Back lettering (lastname + verse boxes combined) is priced off the actual
  // stencil footprint, not word count: take the union bounding box of all back
  // text, pad it by bleedIn on every side (room to glue the reusable rubber
  // cover), round the SHORTER side up to the next real stencil roll width,
  // multiply by the longer side (the cut length) for sqft, then $/sqft,
  // rounded up to the nearest roundToNearest. Lastname-only stays a flat
  // $150/$200 (see FIELD base prices) regardless of this formula.
  backAreaPricing: {
    rollTiersIn: [12.8, 15, 18.75, 21, 25, 30],
    bleedIn: 2,
    ratePerSqFt: 100,
    roundToNearest: 5
  },

  // Real price sheet: "Etching Prices 2026.xlsx" (LASER PRICES FOR WEBSITE
  // tab), confirmed with Pamela 2026-07-19. Spot/Portrait are priced by the
  // size of the ETCHING itself -- stone size doesn't matter. Scenes are
  // priced by the STONE's width instead, which is already companion-aware on
  // its own (a companion stone is naturally wider) -- no separate companion
  // SKU or multiplier exists anywhere in here.
  //
  // Each tier below carries its own real Shopify SKU + a fallback dollar
  // price. getLaserPricePlan() always prefers the live Shopify variant price
  // for that SKU; the number here only applies if that variant hasn't been
  // created yet (or was removed). So: to change any of these prices later,
  // just edit that variant's price in Shopify Admin -- no code change or
  // redeploy needed. The SKUs below are what to create there if they don't
  // exist yet (see `Creative Monument - Laser Pricing Handoff (2026-07-19)`
  // for the exact list to add).
  laserEtching: {
    spotTiers: [
      { maxWidthIn: 4,  maxHeightIn: 6,  label: '4" x 6"',   librarySku: "ADDON_LASER_SPOT_4X6_LIB",   libraryPrice: 190, customSku: "ADDON_LASER_SPOT_4X6_CUSTOM",   customPrice: 240 },
      { maxWidthIn: 5,  maxHeightIn: 7,  label: '5" x 7"',   librarySku: "ADDON_LASER_SPOT_5X7_LIB",   libraryPrice: 200, customSku: "ADDON_LASER_SPOT_5X7_CUSTOM",   customPrice: 250 },
      { maxWidthIn: 8,  maxHeightIn: 10, label: '8" x 10"',  librarySku: "ADDON_LASER_SPOT_8X10_LIB",  libraryPrice: 225, customSku: "ADDON_LASER_SPOT_8X10_CUSTOM",  customPrice: 275 },
      { maxWidthIn: 11, maxHeightIn: 14, label: '11" x 14"', librarySku: "ADDON_LASER_SPOT_11X14_LIB", libraryPrice: 340, customSku: "ADDON_LASER_SPOT_11X14_CUSTOM", customPrice: 390 }
    ],

    // Portraits are always a customer photo -- no library/custom split.
    // additionalFaceFee (below) covers the 3rd+ face beyond a tier's 2.
    portraitTiers: [
      { maxWidthIn: 8,  maxHeightIn: 10, label: '8" x 10"',  sku1Face: "ADDON_LASER_PORTRAIT_8X10_1FACE",  price1Face: 300, sku2Face: "ADDON_LASER_PORTRAIT_8X10_2FACE",  price2Face: 390 },
      { maxWidthIn: 11, maxHeightIn: 14, label: '11" x 14"', sku1Face: "ADDON_LASER_PORTRAIT_11X14_1FACE", price1Face: 350, sku2Face: "ADDON_LASER_PORTRAIT_11X14_2FACE", price2Face: 440 }
    ],
    additionalFaceFee: 75,

    // Full scenes: priced by the STONE's width (parsed from the product
    // title's first NxNxN triplet, same as currentStoneWidthIn() in
    // pamela-clipart-library.js), not the scene artwork's own size. Each
    // tier covers scene height up to sceneMaxHeightIn; every additional
    // sceneHeightStepIn of height (non-compounding) adds one unit of that
    // tier's heightStepSku -- a real, separately-editable Shopify price
    // that's simply set to 20% of the tier's base today, per Pamela.
    sceneStoneTiers: [
      { maxStoneWidthIn: 24, label: "2'-0\"", sku: "ADDON_LASER_SCENE_24IN", price: 400, heightStepSku: "ADDON_LASER_SCENE_24IN_HEIGHT_STEP", heightStepPrice: 80 },
      { maxStoneWidthIn: 30, label: "2'-6\"", sku: "ADDON_LASER_SCENE_30IN", price: 450, heightStepSku: "ADDON_LASER_SCENE_30IN_HEIGHT_STEP", heightStepPrice: 90 },
      { maxStoneWidthIn: 36, label: "3'-0\"", sku: "ADDON_LASER_SCENE_36IN", price: 500, heightStepSku: "ADDON_LASER_SCENE_36IN_HEIGHT_STEP", heightStepPrice: 100 },
      { maxStoneWidthIn: 42, label: "3'-6\"", sku: "ADDON_LASER_SCENE_42IN", price: 550, heightStepSku: "ADDON_LASER_SCENE_42IN_HEIGHT_STEP", heightStepPrice: 110 },
      { maxStoneWidthIn: 48, label: "4'-0\"", sku: "ADDON_LASER_SCENE_48IN", price: 600, heightStepSku: "ADDON_LASER_SCENE_48IN_HEIGHT_STEP", heightStepPrice: 120 }
    ],
    sceneMaxHeightIn: 16,
    sceneHeightStepIn: 4,
    // Flat add-on for customer-uploaded (non-library) scene art -- Pamela's
    // sheet lists this as one flat amount regardless of stone size ("Custom
    // add $200"), so unlike the tiers above it's a single SKU rather than
    // one per stone size. Still a real, separately Shopify-editable price.
    sceneCustomPrepSku: "ADDON_LASER_SCENE_CUSTOM_PREP",
    sceneCustomPrepFee: 200
  },

  // Optional: if you want to cap inscription size (recommended)
  maxBackChars: 600
};
